import getInstance from "../config/api";

export default class Contract {
  static async fetchContracts(params) {
    const instance = getInstance();
    const { data } = await instance.get("/contract", { params });
    return data;
  }

  static async fetchAllCSVContracts(params) {
    const instance = getInstance();
    const data = await instance.get("/contract/csv", { params });
    return data;
  }

  static async fetchContractsConsolidated(params) {
    const instance = getInstance();
    const { data } = await instance.get("/contract/grouped", { params });
    return data;
  }

  static async downloadEvidence(id) {
    const instance = getInstance();
    const data = await instance.get(`/contract/${id}/download-evidence`);
    return data;
  }

  static async createFile(id) {
    const instance = getInstance();
    const data = await instance.get(`/contract/${id}/create-file`);
    return data;
  }

  static async downloadContract(id) {
    const instance = getInstance();
    const data = await instance.get(`/contract/${id}/download`);
    return data;
  }

  static async fetchContractById(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/contract/${id}`);
    return data;
  }

  static async cancelInstallments(body) {
    const instance = getInstance();
    const { data } = await instance.post(`/contract/cancel-installments`, body);
    return data;
  }

  static async downloadPreContractsConsolidated(params) {
    const instance = getInstance();
    const data = await instance.get("/contract/grouped-csv", { params });
    return data;
  }
  static async fetchContractPDF(id) {
    const instance = getInstance();
    const data = await instance.get(`/contract/${id}/create-contract-file`);
    return data;
  }
  static async downloadSettlementLetter(body) {
    const instance = getInstance();
    const { data } = await instance.post(
      `/contract/create-debt-clearance-letter-file`,
      body
    );
    return data;
  }

  static async getDebtClearanceLetterFile(debitLetterFileId) {
    const instance = getInstance();
    const { data } = await instance.get(
      `/contract/get-debt-clearance-letter-file/${debitLetterFileId}`
    );
    return data;
  }

  static async fetchContractIdByExternalId(contractExternalId) {
    const instance = getInstance();

    const { data } = await instance.get(`/contract/contract-external`, {
      params: { contractExternalId },
    });

    return data;
  }
}
